export default "__VITE_ASSET__z_KL_vzq__"